import React from 'react';
import { ApplicationShell } from './helpers/ApplicationShell';
import { AppLayout } from './helpers/AppLayout';
import {
  APP_CONTAINER_BASE_URL,
  PROGRAM_ACCOUNTS,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import {
  AuthContext,
  initialAuthContext,
} from 'src/state/providers/AuthProvider';

export const DSAArticle11PocWidget = () => {
  return (
    <AuthContext.Provider
      value={{
        ...initialAuthContext,
        preferredAccountId: PROGRAM_ACCOUNTS.DSA_POC,
        clientId: UI_CLIENTS.RegulatorCentral,
        customerId: '', //only anonymous use-case
        appContainerBaseUrl: APP_CONTAINER_BASE_URL.ARTICLE_11_DSA,
        isAnonymousUser: true,
      }}
    >
      <ApplicationShell>
        <AppLayout />
      </ApplicationShell>
    </AuthContext.Provider>
  );
};
